import Vue from 'vue'
import { isEmpty, isNotEmpty, getDate, deepClone, tranNumber, countdownTime, hideToolbar } from '@/utils/validate'
/* import FastClick from 'fastclick' */
import App from './App'
import store from './store'
import router from './router'
import cookie from 'js-cookie'
import qs from 'qs'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'lib-flexible'
import './assets/styles/index.less'
import VueVideoPlayer from 'vue-video-player' // 视频播放器
import 'video.js/dist/video-js.css'
Vue.use(VueVideoPlayer)
import vueClipBoard from 'vue-clipboard2'
Vue.use(vueClipBoard)
import VConsole from 'vconsole'
const isDebug = false
if (isDebug) {
  new VConsole()
}
Vue.use(Vant)
/* FastClick.attach(document.body) */
Vue.prototype.$cookie = cookie
Vue.prototype.$qs = qs
Vue.prototype.$deepClone = deepClone
Vue.prototype.$tranNumber = tranNumber
Vue.prototype.$countdownTime = countdownTime
Vue.config.productionTip = false

// 定义全局函数
Vue.prototype.$isEmpty = isEmpty
Vue.prototype.$isNotEmpty = isNotEmpty
Vue.prototype.$getDate = getDate
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js